function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5 3L29 2.5L26 5.5L31.5 26L29 30L22.5 32.5L20 34L21 39L24.5 40L28.5 39L36.5 45L37.5 48.5L56.5 43V38.5L58.5 31L54 13.5L35.5 13L32.5 3Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.7789 12.9743L53.8504 13.4029L58.6361 31.1172L55.9218 39.26L56.9932 43.3315",
  stroke: "#6C8936",
  strokeWidth: 2.14286,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.8504 14.2606L43.6361 21.1892",
  stroke: "#6C8936",
  strokeWidth: 2.14286,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9933 14.4747L49.8504 21.3319",
  stroke: "#6C8936",
  strokeWidth: 2.14286,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.1361 48.6176L36.0646 44.5462L28.2789 39.2605L25.1361 40.1176C23.0646 40.6891 20.9218 39.4034 20.3503 37.3319L20.1361 36.6176C19.5646 34.5462 20.8503 32.4033 22.9218 31.8319L24.7075 31.3319L25.3503 31.1891L27.2075 30.6891C30.0646 29.9033 31.7075 27.0462 30.9932 24.1891L30.8503 23.7605L30.7789 23.5462L26.2075 6.47478C25.7075 4.54621 26.8503 2.61763 28.7075 2.11763C30.6361 1.61763 32.5646 2.76049 33.0646 4.61763L37.4218 20.9748",
  stroke: "#6C8936",
  strokeWidth: 2.14286,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.2457 4.61373L18.2462 4.61348L17.9277 4.00518L17.9562 3.91388L17.8649 3.88533L17.2091 2.63287L7.30603 7.81825L8.34311 9.79887L15.1322 6.24402L8.76 26.624L5.20471 19.8341L3.22409 20.8712L7.37256 28.794L7.37251 28.794L8.40958 30.7746L18.3127 25.5892L17.2756 23.6086L10.726 27.038L16.9839 7.02359L20.4135 13.5735L22.3941 12.5364L18.2457 4.61373Z",
  fill: "#6C8936"
});

function SvgTouchControlZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchControlZoom);
export default __webpack_public_path__ + "static/media/touch-control-zoom.26546c45.svg";
export { ForwardRef as ReactComponent };